<template>
  <div>
    <section class="study">
      <h1 style="font-size: 13px" class="bold my-3">Thông tin tổng quan</h1>
      <div class="table-responsive w-100">
        <table class="table table-bordered">
          <thead class="table-secondary">
          <tr class="" style="font-size: 13px">
            <th>Khóa học</th>
            <th>Lớp học</th>
            <th>Lộ trình học</th>
            <th>Đi học</th>
            <th>Làm BTVN</th>
            <th>Tích luỹ năng lực</th>
            <th>Kết quả đầu ra</th>
            <th>Ngày khai giảng</th>
            <th>Ngày kết thúc</th>
            <th>Tình trạng bảo hành</th>
            <th class="text-center">Hành động</th>
          </tr>
          </thead>
          <tbody v-if="listStudy.length === 0">
          <tr class="text-center">
            <td colspan="8">Không có dữ liệu</td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr style="font-size: 13px" v-for="(item, index) of listStudy" :key="index">
            <td>{{ item.course_name }}</td>
            <td>{{ item.classroomName ? item.classroomName : '(Chưa có thông tin)' }}</td>
            <td>{{ item.schedule }}</td>
            <td>{{ item.schedule_number }}</td>
            <td>{{ item.homework }}</td>
            <td>{{ item.capacity_building }}</td>
            <td>
              <span :class="item.output === 1 ? 'bg-green text-white' : item.output === 2 ? 'bg-red text-white' : ''" style="padding: 4px 8px; border-radius: 4px">
                {{renderOutput(item.output)}}</span>
            </td>
            <td>{{convertTime(item?.startDate)}}</td>
            <td>{{convertTime(item?.endDate)}}</td>
            <td>
              <template v-if="item.pass_guarantee && item.pass_guarantee.status == 2">
                  <div v-if="item?.startDate">
                   <el-tooltip
                      v-if="item.pass_guarantee.errors && item.pass_guarantee.errors.length > 0"
                      effect="dark"
                      placement="top"
                  >
                      <div slot="content">
                          <div
                              v-for="(error, index) in item.pass_guarantee.errors"
                              :key="index"
                          >
                              - {{ error.message }}
                          </div>
                      </div>

                      <el-button
                          size="small"
                          class="text-white rounded"
                          type="danger"
                      >
                          Mất bảo hành
                      </el-button>
                  </el-tooltip>
                   <el-button
                      v-else
                      size="small"
                      class="text-white rounded"
                      type="danger"
                  >
                      Mất bảo hành
                  </el-button>
                  </div>
              </template>

              <el-button
                  v-else
                  size="small"
                  class="text-white rounded"
                  type="success"
              >
                  Pass bảo hành
              </el-button>
            </td>
            <td class="text-center">
              <button class="btn btn-info btn-sm btn-icon waves-effect waves-themed" @click="openModal(item)">
                <i class="fa fa-eye"></i>
              </button>

<!--                <button class="btn btn-primary btn-sm btn-icon waves-effect waves-themed ml-2"-->
<!--                        @click="changeWarrantyConditions(item)"-->
<!--                        v-if="item?.startDate">-->
<!--                    <i class="el-icon-edit-outline"></i>-->
<!--                </button>-->
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
    <el-dialog
        title="Tình hình học tập"
        :visible.sync="isOpen" width="60%"
    >
      <div>
        <div class="class-title ml-7 d-flex">
          <p style="min-width: 60px">Lớp học:</p> <span>{{ classroomName}}</span>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3 form-group">
              <label>Lộ trình học:</label>
              <input type="text" class="form-control" :value="studentRegisterCourse && studentRegisterCourse.schedule" disabled>
            </div>
            <div class="col-md-3 form-group">
              <label>Số buổi đi học:</label>
              <input type="text" class="form-control" :value="studentRegisterCourse && studentRegisterCourse.schedule_number" disabled>
            </div>
            <div class="col-md-3 form-group">
              <label>Số buổi làm bài tập:</label>
              <input type="text" class="form-control" :value="studentRegisterCourse && studentRegisterCourse.homework" disabled>
            </div>
            <div class="col-md-3 form-group">
              <label>Kết quả đầu ra:</label>
              <input type="text" class="form-control" :value="renderOutput(output)" disabled>
            </div>
          </div>
          <div class="table-responsive overflow-auto">
            <table class="table table-vertical-center table-hover border">
              <thead>
              <tr>
                <th>
                  <span style="word-break: break-word">Buổi học</span>
                </th>
                <th>Thời gian học</th>
                <th>Điểm danh</th>
                <th>Tích lũy năng lực</th>
                <th>HV đánh giá</th>
                <th>Bài tập về nhà</th>
                <th>GV nhận xét</th>
              </tr>
              </thead>
              <tbody v-if="loading">
              <tr>
                <td colspan="6" class="text-center">
                  <div class="d-flex justify-content-center w-100">
                    <i class="el-icon-loading"></i>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else-if="schedules.length > 0">
              <tr v-for="(item, key) in schedules" :key="key">
                <td>
              <span style="word-break: break-word; text-transform: capitalize">
                {{ checkLessonToString(item.lesson, item.type, schedules.length) }}
              </span>
                </td>
                <td>{{item.time}}</td>
                <td>
                  <label
                      v-if="item.attendance"
                      class="px-2 py-1 label-rounded"
                      style="white-space: nowrap"
                      :class="item.attendance === 'Vắng mặt' ? 'bg-red text-white' :
                      item.attendance === 'Có mặt' ? 'bg-green text-white' :
                      item.attendance === 'Có phép' ? 'bg-yellow text-black' :
                      item.attendance === 'Ngừng học' ? 'bg-gray1 text-white' : 'bg-gray2'"
                  >{{item.attendance}}</label>
                </td>
                <td>
                  <span v-if="!item.capacityBuilding"></span>
                  <el-tooltip
                    v-else
                    class="item"
                    effect="light"
                    placement="top"
                    :content="''"
                    popper-class="custom-tooltip"
                  >
                    <template #content>
                      <ul class="tooltip-content">
                        <li
                          v-for="(i, j) in item.tooltip"
                          :key="j"
                          :class="[i.is_pass ? 'el-icon-circle-check text-green' : 'el-icon-circle-close text-red']"
                        >
                          {{ i.name }}
                        </li>
                      </ul>
                    </template>

                    <el-button size="mini">{{ item.capacityBuilding }}</el-button>
                  </el-tooltip>
                </td>
                <td>
                  <el-tooltip v-if="item.studentFeedback" :content="item.studentFeedback" placement="top">
                    <label
                        class="px-2 py-1 label-rounded"
                        style="white-space: nowrap"
                        :class="item.rating > 2 ? 'bg-green text-white' : item.rating <= 2 && item.rating > 0 ? 'bg-red text-white' : 'bg-gray2'"
                    >{{ item.rating + ' sao' }}</label>
                  </el-tooltip>
                  <label
                      v-else-if="item.rating > 0"
                      class="px-2 py-1 label-rounded"
                      style="white-space: nowrap"
                      :class="item.rating > 2 ? 'bg-green text-white' : item.rating <= 2 ? 'bg-red text-white' : 'bg-gray2'"
                  >{{ item.rating + ' sao' }}</label>
                  <label v-else-if="item.attendance" class="px-2 py-1 label-rounded bg-gray2">
                    Không đánh giá
                  </label>
                </td>
                <td>
                  <label
                      v-if="item.homeworkStatus !== ''"
                      class="px-2 py-1 label-rounded"
                      style="white-space: nowrap"
                      :class="item.homeworkStatus === 'Hoàn thành' ? 'bg-green text-white'
                      : item.homeworkStatus === 'Không có bài tập' ? 'bg-gray2 text-white'
                      : item.homeworkStatus === 'Nộp muộn' ? 'bg-red text-white'
                      : item.homeworkStatus === 'Chưa làm' ? 'bg-blue'
                      : item.homeworkStatus === '' ? 'bg-gray2' : ''"
                  >{{ item.homeworkStatus }}</label>
                </td>
                <td>
                    <div v-if="assessmentHistory(item).length">
                        <el-button
                            v-for="(assessment, assessmentIndex) in assessmentHistory(item)"
                            :key="assessment.assessment_id"
                            type="text"
                            class="btn btn-xs btn-icon"
                            :title="`Xem đánh giá cuối khóa ${assessmentIndex + 1}`"
                            @click="showAssessment(assessment.assessment_id)"
                        >
                            <i class="far fa-eye"></i>
                        </el-button>
                    </div>
                    <span v-else-if="item.end_course_assessment?.can_author">Chưa đánh giá</span>
                    <div v-if="item.type_comment_phase">
                        <el-tooltip v-if="!item.comments && !item.comment_phase && !item.autoComment" content="Giảng viên chưa nhận xét" placement="top">
                            <el-button
                                :disabled="item.lesson === 'Buổi khai giảng' || item.lesson === 'Final Test' || item.lesson === 'Buổi tổng kết'"
                                type="text" class="btn btn-xs btn-icon" style="background: transparent !important; height: 30px; display: flex; align-items: center; justify-content: center;"
                                @click="showModalCommentDetail(item)">
                                <i class="far fa-eye"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-else content="Xem chi tiết" placement="top">
                            <el-button
                                style="height: 30px; display: flex; align-items: center; justify-content: center; background: #2196F3"
                                type="text" class="btn btn-info btn-sm btn-icon waves-effect waves-themed" @click="showModalCommentDetail(item)">
                                <i class="far fa-eye" style="color: white"></i>
                            </el-button>
                        </el-tooltip>
                    </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="7" class="event-title no-data text-center">Chưa có dữ liệu</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="showCommentDetail"
        :width="assessmentId ? '900px' : '50%'"
    >
      <div v-if="showCommentDetail">
          <end-course-assessment-detail
              v-if="assessmentId"
              :assessment-id="assessmentId"
          ></end-course-assessment-detail>
          <modal-detail-regiment v-else-if="(centerId == 516 || centerId == 295) && version==2" :studyDetail="selectedClassrom"></modal-detail-regiment>
          <modal-detail-lesson-first v-else-if="type_comment_phase == 1 && commentDetail?.form_new" :commentDetail="commentDetail"></modal-detail-lesson-first>
          <modal-detail-lesson-mid-or-last v-else-if="(type_comment_phase == 2 || type_comment_phase == 3) && commentDetail?.form_new" :commentDetail="commentDetail"
                                           :commentLessonOld="commentLessonOld" :lesson="lesson">
  
          </modal-detail-lesson-mid-or-last>
        <div class="mx-5" v-else>
          <p style="color: black; word-break: break-word">{{ autoComment }}</p>
          <div v-if="commentDetail !== null">
            <h5 style="color: #0a0a0a; margin-bottom: 5px; font-weight: 700">Chi tiết buổi học</h5>
            <div v-for="item of commentDetail" style="margin-bottom: 15px" :key="item.title">
              <div v-if="item.recommendAuto !== '' || item.feedback !== ''">
                <label class="label-detail">
                  {{item.title === 1 ? 'Tính chủ động'
                    : item.title === 2 ? 'Độ tập trung' : 'Độ tiếp thu' }}
                </label>
                <p style="color: black; word-break: break-word;" v-if="item?.recommendAuto !== ''">
                  {{ item?.recommendAuto }}
                </p>
                <div style="display: flex; align-content: center; word-break: break-word" v-if="item?.feedback !== ''">
                  <div class="feedback"></div>
                  <p style="margin: auto; word-break: break-word;">{{ item?.feedback }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="comment_phase">
            <label style="font-weight: 700; color: #0a0a0a">Nhận xét tổng quan giai đoạn {{ comment_phase.start }} - {{ comment_phase.end }}</label>
            <p style="color: #0a0a0a; word-break: break-word">{{ comment_phase?.comment }}</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import {StudyDetail} from "../models/StudyDetail";
import {
  CUSTOMER_SCHEDULE_LIST,
  GET_DETAIL_CUSTOMER_STUDY,
  GET_TEACHER_COMMENT,
  CHANGE_WARRANTY_CONDITION
} from "../../../../core/services/store/customer/customer.module";
import WarrantyTooltip from "./warranty-tooltip.vue";
import ModalDetailLessonFirst from "./component/ModalDetailLessonFirst";
import ModalDetailLessonMidOrLast from "./component/ModalDetailLessonMidOrLast";
import Swal from "sweetalert2";
import ModalDetailRegiment from "./component/ModalDetailRegiment.vue";
import EndCourseAssessmentDetail from "./component/EndCourseAssessmentDetail.vue";

export default {
  name: "customer-study",
  components: {
    WarrantyTooltip,
    ModalDetailLessonFirst,
    ModalDetailLessonMidOrLast,
    ModalDetailRegiment,
    EndCourseAssessmentDetail
  },
  data() {
    return {
      id: null,
      listStudy: [],
      isOpen: false,
      studentRegisterCourse: {},
      classroomName: {},
      flag: false,
      lesson: 0,
      schedules: [],
      loading: true,
      showCommentDetail: false,
      commentDetail: [],
      comment_phase: {},
      autoComment: '',
      output: '',
      commentLessonOld: {},
      dialogTitle: '',
      type_comment_phase: '',
      version : null,
      classroom_id : null,
      centerId : null,
      userId : this.$route.params.id,
      selectedClassrom: {},
      assessmentId: null
    };
  },
  mounted() {
    this.getListStudy(this.userId);
  },
  methods: {
    getListStudy(id) {
      this.$store.dispatch(GET_DETAIL_CUSTOMER_STUDY, id).then((data) => {
        this.listStudy = data.data;
      });
    },
    openModal(studentRegisterCourse) {
      this.getSchedule(studentRegisterCourse.id);
      this.studentRegisterCourse = studentRegisterCourse;
      this.classroomName = studentRegisterCourse.classroom_name;
      this.isOpen = true;
      this.flag = !this.flag;
    },
    renderOutput(output) {
      switch (output) {
        case 1:
          return  'Pass';
        case 2:
          return 'Fail'
        default:
          return  'Chưa có';
      }
    },
    getClassGuarantee(value) {
      switch (value) {
        case 'Còn bảo hành':
          return 'bg-blue-500'
        case 'Mất bảo hành':
          return 'bg-gray-300'
        default:
          return ''
      }
    },
    convertTime(time){
      if (!time) return ''
      return moment(time).format('DD/MM/YYYY')
    },
    assessmentHistory(item) {
      const assessment = item.end_course_assessment
      if (assessment?.history?.length) return assessment.history
      return assessment?.assessment_id ? [assessment] : []
    },
    showAssessment(assessmentId) {
      this.assessmentId = assessmentId
      this.dialogTitle = 'Đánh giá chỉ định cuối khóa'
      this.showCommentDetail = true
    },
    showModalCommentDetail (item) {
      this.assessmentId = null
      this.lesson = item.lesson
      this.commentDetail = item.comments
      this.comment_phase = item.commentPhase
      this.autoComment = item.autoComment
      this.type_comment_phase = item.type_comment_phase
      this.version = item?.version
      this.classroomId = item?.classroom_id
      this.selectedClassrom=item;
      this.showCommentDetail = true
      if (this.type_comment_phase > 1 && !((this.centerId === 516 || this.centerId ===  295) && this.version == 2))
      {
        this.getTeacherCommentLessonOld(this.type_comment_phase)
      }
    this.getTitle();
    },
    checkLessonToString(item, type, totalLesson) {
      if(item === 1) {
        return 'Buổi khai giảng'
      }
      if(type === 'test') {
        if(item === totalLesson - 1) {
          return 'Final Test'
        } else {
          return 'Mid Term Test'
        }
      }
      if (item === totalLesson) {
        return 'Buổi tổng kết'
      }
      return `buổi ${item}`
    },
    getSchedule(id) {
      this.$store.dispatch(CUSTOMER_SCHEDULE_LIST, id).then((res) => {
        this.output = res.data.is_pass
        this.loading = false
        const result = res.data.result
        this.centerId = res?.data?.center_id
        this.schedules = result.map(item => new StudyDetail(
            item?.lesson,
            item?.day,
            item?.attendance_value,
            item?.rating,
            item?.homework_status,
            item?.teacher_comment,
            item?.comment_phase,
            item?.type,
            result?.length,
            item?.student_feedback,
            item?.comment,
            item?.attendance_reason,
            item?.schedule_type,
            item?.capacity_building,
            item?.tooltip,
            item?.type_comment_phase,
            item?.version,
            item?.classroom_id,
            item?.end_course_assessment
        ));
      }).catch()
    },
    getTeacherCommentLessonOld(type_comment_phase)
      {
          let lessonOld = this.getCommentAlumni(type_comment_phase);
          this.$store.dispatch(GET_TEACHER_COMMENT, {
              class_id: this.studentRegisterCourse.classroom_id,
              lesson: lessonOld,
              user_id: this.userId
          }).then((res) => {
              this.commentLessonOld = res.data.comments
          });
      },
    getTitle()
    {
      let title = 'Nhận xét của giảng viên về';
      if (this.type_comment_phase == 1 && this?.commentDetail?.form_new)
      {
        return this.dialogTitle = title + ' giai đoạn Đầu khoá';
      }
      if (this.type_comment_phase == 2 && this.comment_phase && this.commentDetail?.form_new)
      {
        return this.dialogTitle = title + ' giai đoạn Giữa khoá';
      }
      if (this.type_comment_phase == 3 && this?.commentDetail?.form_new)
      {
        return this.dialogTitle = title +  ' giai đoạn Cuối khoá';
      }

      return this.dialogTitle = title + ' buổi ' + this.lesson;
    },
    getCommentAlumni(type_comment_phase)
    {
      const lessonOld = this.schedules.find(item => item.type_comment_phase == type_comment_phase - 1)
      if (!lessonOld)
      {
        return '';
      }
      return lessonOld.lesson;
    },

    async changeWarrantyConditions(item) {
      const currentStatus = Number(item?.pass_guarantee?.status ?? 0)
      const nextStatus = currentStatus === 2 ? 1 : 2

      const result = await Swal.fire({
          title: 'Xác nhận thay đổi',
          text: `Bạn có chắc muốn ${nextStatus ? 'bật' : 'tắt'} điều kiện bảo hành không?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Huỷ',
          reverseButtons: true
      })

      if (!result.isConfirmed) {
          return
      }

      const payload = {
          student_register_course_id : item.id ?? null,
          next_status : nextStatus
      };

      await this.$store.dispatch(CHANGE_WARRANTY_CONDITION, payload).then((res) => {
          if(!res.error) {
              this.listStudy = this.listStudy.map(i => {
                  if (item.id === i.id) {
                      return {
                          ...i,
                          pass_guarantee: {
                              ...i.pass_guarantee,
                              status: nextStatus,

                          },
                      };
                  }
                  return i;
              });

              this.$message.success('Cập nhật điều kiện bảo hành thành công')
          }

      }).catch(e => {
          console.log('12312312', e)
          this.$message.error(e?.data?.message || 'Cập nhật điều kiện bảo hành thất bại')
      })
    }
  },
};
</script>

<style scoped>
a{
  width: 100px;
  overflow: auto;
}
.view-feedback {
  border: none;
  margin-left: 20px;
  padding: 6px 10px;
}
.view-feedback:hover {
  color: #0BB7AF;
}
.label-rounded {
  border-radius: 5px;
  padding: 3px 6px;
}
.bg-red {
  background: #BF0000;
}
.bg-green {
  background: #128300;
}
.bg-gray1 {
  background: #3D3D3D
}
.bg-yellow {
  background: #FFC700;
}
.bg-gray2 {
  background: #DEDEDE
}
.label-detail {
  background: #FEC803;
  padding: 4px 6px;
  border-radius: 4px;
  color: black;
}
.feedback {
  height: 45px;
  width: 1px;
  margin:0 10px;
  background: #858585;
}
.bg-blue {
  background: #5959ed;
  color: white;
}

.bg-blue-500 {
  color: white;
  background: #1BC5BD
}

.bg-gray-300 {
  background: #6C6C6C;
  color: white;
}


.tooltip-content {
  list-style: none;
  padding: 0;
  margin: 0;
}


.text-green {
  color: #67c23a;
}

.text-red {
  color: #f56c6c;
}

.custom-tooltip {
  max-width: 300px;
  padding: 8px;
  font-family: 'Arial', sans-serif;
}
li {
  display: block;
  margin-bottom: 4px; /* tạo khoảng cách giữa các dòng */
}
.tooltip-content li {
  display: block;
  margin-bottom: 4px;
}
</style>
